import React from 'react';
import styles from './Hero.module.css';

const TRUST_NOTES = [
  'No Reddit password needed',
  'Drip delivery',
  'Aged accounts only',
  'Full dashboard',
];

export default function Hero() {
  const handleScroll = (href) => {
    const target = document.querySelector(href);
    if (target) {
      window.scrollTo({ top: target.offsetTop - 80, behavior: 'smooth' });
    }
  };

  return (
    <section className={styles.hero}>
      <div className={styles.glow} />
      <div className="container">
        <div className={styles.badge}>
          <span className={styles.badgeDot} />
          Now accepting clients
        </div>

        <h1 className={styles.heading}>
          Reddit Marketing Agency for B2B Brands That Want <em className={styles.accent}>Qualified Leads</em>
        </h1>

        <p className={styles.sub}>
          Reddit is where real buying decisions are made. We put your brand inside
          those conversations.
        </p>

        <div className={styles.cta}>
          <button
            className="btn btn-primary btn-lg"
            onClick={() => handleScroll('#pricing')}
          >
            See plans &amp; pricing →
          </button>
          <button
            className="btn btn-outline btn-lg"
            onClick={() => handleScroll('#how')}
          >
            How it works
          </button>
        </div>

        <div className={styles.trustRow}>
          {TRUST_NOTES.map((note) => (
            <span key={note} className={styles.trustItem}>
              <span className={styles.check}>✓</span>
              {note}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
